import React from 'react';
import { GLOBE_IMAGE } from '../mock';

export default function ConexaoGlobal() {
  return (
    <section className="relative w-full py-24 md:py-32 bg-[color:var(--sd-bg)] overflow-hidden">
      <div className="absolute inset-0 sd-grid-bg opacity-40 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div className="relative order-2 lg:order-1">
          <div className="absolute -inset-6 border border-[rgba(34,230,230,0.2)] pointer-events-none" />
          <img
            src={GLOBE_IMAGE}
            alt="Globe network"
            className="w-full h-auto relative z-10"
          />
          <div className="mt-4 text-[10px] tracking-[0.3em] text-[color:var(--sd-cyan)]/70 font-mono relative z-10">
            [ REDE ATIVA // 4.827 NÓS CONECTADOS ]
          </div>
        </div>
        <div className="order-1 lg:order-2">
          <div className="sd-rule mb-6" />
          <h2 className="font-display font-black text-[color:var(--sd-cyan)] text-3xl md:text-5xl leading-[1.1] tracking-widest sd-glow">
            CONEXÃO<br />GLOBAL
          </h2>
          <div className="mt-8 space-y-5 text-[color:var(--sd-text)]/85 leading-relaxed font-mono">
            <p>
              Conectamos jogadores em todo o território nacional através de uma
              infraestrutura de ponta. Nossa rede de conexão permite que o
              Brasil se torne mais conectado nos dardos em território nacional
              e com conexão ao resto do mundo.
            </p>
            <p>
              Com tecnologia exclusiva, garantimos que cada ponto de instalação
              seja parte de uma rede viva, onde a competição profissional e o
              entretenimento nunca se interrompam.
            </p>
          </div>
          <div className="mt-10 grid grid-cols-3 gap-4">
            {[
              { k: 'NÓS', v: '4.8K' },
              { k: 'PAÍSES', v: '32' },
              { k: 'UPTIME', v: '99.9%' },
            ].map((s) => (
              <div key={s.k} className="sd-panel sd-brackets p-4 text-center">
                <div className="font-display text-[color:var(--sd-cyan)] text-2xl md:text-3xl font-black">
                  {s.v}
                </div>
                <div className="text-[10px] tracking-[0.3em] text-[color:var(--sd-muted)] mt-1 font-mono">
                  {s.k}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
